import { Box, HStack, Text } from '@chakra-ui/react'

export type FloatingTooltipKvRowLayout = 'inlineLeft' | 'spaceBetween'

type FloatingTooltipKvRowProps = {
  label: string
  value: string
  /** Pie tooltips use space-between; cartesian tooltips use inline left-aligned label + value. */
  layout?: FloatingTooltipKvRowLayout
}

/** 12px / 400 label, 12px / 700 value. */
export const FloatingTooltipKvRow = ({
  label,
  value,
  layout = 'inlineLeft',
}: FloatingTooltipKvRowProps) => {
  if (layout === 'spaceBetween') {
    return (
      <HStack
        justify="space-between"
        w="100%"
        align="baseline"
        spacing="12px"
        minW={0}
      >
        <Text
          fontSize="12px"
          fontWeight="400"
          color="presets.neutral.0"
          noOfLines={1}
          overflow="hidden"
          textOverflow="ellipsis"
          flex="1"
          minW={0}
          textAlign="left"
        >
          {label}
        </Text>
        <Text
          fontSize="12px"
          fontWeight="700"
          color="presets.neutral.0"
          flexShrink={0}
          textAlign="right"
        >
          {value}
        </Text>
      </HStack>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      flexWrap="nowrap"
      alignItems="baseline"
      minW={0}
      w="100%"
      sx={{ whiteSpace: 'nowrap' }}
    >
      <Box
        as="span"
        fontSize="12px"
        fontWeight="400"
        color="presets.neutral.0"
        flexShrink={1}
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {label}:{'\u00A0'}
      </Box>
      <Box
        as="span"
        fontSize="12px"
        fontWeight="700"
        color="presets.neutral.0"
        flexShrink={0}
      >
        {value}
      </Box>
    </Box>
  )
}
